import { defineStore } from 'pinia'
import storeStorage from '@/stores/modules/storeStorage.js'

export const useAppStore = defineStore('page', {
  state: () => ({
    // 页面查询参数
    queryParams: {
      brandId: 0,
      keywordId: 0, // 关键词 0：全部
      cycleType: 1, // 1: 按天 2: 按周 3: 按月 4: 自定义
      beginDate: '', // 开始日期 YYYY-MM-DD
      endDate: '', // 结束日期 YYYY-MM-DD
      brandLocationId: 0 // 地区 0：全部
    },
    // 当前项目类型：1 标准项目，2 快速评估
    brandType: 1
  }),
  actions: {
    setQueryParams(payload, val) {
      // 批量修改
      if (typeof payload === 'object') {
        this.queryParams = { ...this.queryParams, ...payload }
      } else {
        // 单个修改
        this.queryParams[payload] = val
      }

      // 清理历史草稿残留字段，避免随接口参数带出
      if ('customDate' in this.queryParams) {
        delete this.queryParams.customDate
      }
    },
    setBrandType(val) {
      this.brandType = val
    },
    reset() {
      this.$reset()
    }
  },
  persist: {
    pick: ['queryParams', 'brandType'],
    storage: storeStorage,
    afterHydrate: ({ store }) => {
      const q = store.queryParams || {}
      if (!('beginDate' in q)) q.beginDate = ''
      if (!('endDate' in q)) q.endDate = ''
      // 自定义无完整日期视为无效，回退由 SelectCycleType 补默认
      if (!q.beginDate || !q.endDate) {
        q.cycleType = q.cycleType === 4 ? 1 : q.cycleType || 1
        q.beginDate = ''
        q.endDate = ''
      }
      // 清理历史草稿残留
      if ('customDate' in q) {
        delete q.customDate
      }
    }
  }
})

export default useAppStore
